// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  min-height: 32px;
  background: #2e1a47;
  width: 100%;
  position: absolute;
  bottom: 0;
  color: #ffffff;
  font-size: 0.8rem;
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,mBCHK;EDIL,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cCNM;EDON,iBAAA;EACA,YAAA;AADF","sourcesContent":["@import '../../../styles/variables';\n\nfooter {\n  min-height: 32px;\n  background: $plum;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  color: $white;\n  font-size: 0.8rem;\n  padding: $spacer / 2;\n}\n","// Variables\n$plum: #2e1a47;\n$white: #ffffff;\n$light-gray: #e5e5e5;\n\n$spacer: 16px;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
